<template>
    <input
        :id="id"
        :class="[
            'form-control',
            (wrapped == 'true') ? '' : typeClass,
            (wrapped == 'true') ? '' : 'bs-date-picker',
            (bsDatePickerXml == 'true') ? 'bs-date-picker-xml' : '',
            controlClass
        ]"
        type="text"
        :name="name"
        :data-date-format="formatAttr"
        :title="title"
    >
</template>

<script>
'use strict';

/* eslint vue/require-prop-types: "off" */

import { _commons } from '../commons-global/index';

export const typeClasses = {
    date: {
        clazz: 'date-picker',
        format: 'DD/MM/YYYY',
        options: { pickTime: false },
    },
    datetime: {
        clazz: 'datetime-picker',
        format: 'DD/MM/YYYY HH:mm',
        options: {},
    },
};
export default {
    //type = date, datetime
    model: {
        prop: 'rawValue',
    },
    props: ['controlClass', 'name', 'id', 'title', 'rawValue', 'type', 'wrapped', 'disabled', 'bsDatePickerXml'],
    data() {
        const typeClass = typeClasses[this.type];
        return {
            changing: false,
            typeClass: typeClass.clazz,
            formatAttr: typeClass.format,
        };
    },
    watch: {
        rawValue(newVal) {
            if(!this.changing) {
                _commons.tabledata.setControlValue($(this.$el), newVal);
            }
        },
        disabled(newVal) {
            this._disabledChange(newVal);
        },
    },
    mounted() {
        if(this.wrapped != 'true') {
            const typeClass = typeClasses[this.type];
            $(this.$el).datetimepicker(Object.assign({ language: 'it' }, typeClass.options));
            $(this.$el).on('dp.change auto-changed', () => {
                this.changed();
            });
        }
        this.$nextTick(() => {
            this._disabledChange(this.disabled);
            const value = _commons.tabledata.getControlValue($(this.$el));
            const isEmpty = (!value && !this.rawValue);
            if(!isEmpty && (value !== this.rawValue)) {
                _commons.tabledata.setControlValue($(this.$el), this.rawValue);
            }
        });
    },
    beforeDestroy() {
        if(this.wrapped != 'true') {
            this.getDatePicker().destroy();
        }
    },
    methods: {
        _disabledChange(newVal) {
            const datePicker = this.getDatePicker();
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            (String(newVal) == 'true') ? datePicker.disable() : datePicker.enable();
        },
        getDatePicker() {
            return (this.wrapped == 'true') ? this.$parent.getDatePicker() : $(this.$el).data('DateTimePicker');
        },
        changed() {
            const value = _commons.tabledata.getControlValue($(this.$el));
            this.changing = true;
            try {
                this.$emit('input', value);
            } finally {
                this.changing = false;
            }
        },
    },
};
</script>
